import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { getDisabledColorOpacity, getHoverColorOpacity, } from '../../helpers/getColorOpacity';
const colorMap = {
    light: {
        action: {
            background: staticColors.buttonLightActionBackground,
            text: staticColors.buttonLightActionText,
        },
        danger: {
            background: staticColors.buttonLightDangerBackground,
            text: staticColors.buttonLightDangerText,
        },
        grey: {
            background: staticColors.buttonLightGreyBackground,
            text: staticColors.buttonLightGreyText,
        },
    },
    dark: {
        action: {
            background: staticColors.buttonDarkActionBackground,
            text: staticColors.buttonDarkActionText,
        },
        danger: {
            background: staticColors.buttonDarkDangerBackground,
            text: staticColors.buttonDarkDangerText,
        },
        grey: {
            background: staticColors.buttonDarkGreyBackground,
            text: staticColors.buttonDarkGreyText,
        },
    },
    underline: {
        action: {
            background: staticColors.buttonUnderlineBackground,
            text: staticColors.buttonLightActionText,
        },
        danger: {
            background: staticColors.buttonUnderlineBackground,
            text: staticColors.buttonLightDangerText,
        },
        grey: {
            background: staticColors.buttonUnderlineBackground,
            text: staticColors.buttonLightGreyText,
        },
    },
};
export const useButtonColors = ({ color, variant }) => {
    const colors = colorMap[variant][color];
    return {
        text: {
            normalState: colors.text,
            disabledState: getDisabledColorOpacity(colors.text),
            hoveredState: getHoverColorOpacity(colors.text),
        },
        background: {
            normalState: colors.background,
            disabledState: getDisabledColorOpacity(colors.background),
            hoveredState: getHoverColorOpacity(colors.background),
        },
    };
};
export const getButtonHeight = (size) => {
    const buttonHeightMap = {
        large: sizes.button.largeHeight,
        small: sizes.button.smallHeight,
    };
    return buttonHeightMap[size];
};
